import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import IValuer from './IValuer';

export function valuersSelector(state: IGlobalState): IDictionary<IValuer> {
    return state.valuers.valuers;
}
